import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { ParametersService } from '@modules/business-accounts/services/parameters/parameters.service';

@Component({
  selector: 'ba-tax-country-detail-form',
  templateUrl: './tax-country-detail-form.component.html',
  styleUrls: ['./tax-country-detail-form.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class TaxCountryDetailFormComponent implements OnInit {
  constructor(public readonly paramsService: ParametersService) {}

  ngOnInit(): void {}
}
